const Panels = (panelContainerId: string, callback?: () => void) => {
    const panelContainer = document.getElementById(panelContainerId);

    if (!panelContainer) {
        console.warn(`Panel container with id "${panelContainerId}" not found.`);
        return;
    }

    // Function to deactivate all panels
    const deactivateAllPanels = () => {
        const allPanels =
            panelContainer.querySelectorAll<HTMLElement>('[data-panelid]');
        allPanels.forEach(panel => {
            panel.classList.remove('active'); // Remove the active class to hide all panels
        });
    };

    // Function to deactivate all buttons
    const deactivateAllButtons = () => {
        const allButtons =
            panelContainer.querySelectorAll<HTMLButtonElement>('.js-btn-tab-nav');
        allButtons.forEach(button => {
            button.classList.remove('active'); // Remove the active class from all buttons
        });
    };

    // Function to toggle the panel visibility with optional callback
    const togglePanel = (panelId: string) => {
        const panel = panelContainer.querySelector(`[data-panelid="${panelId}"]`);

        if (!panel) {
            return; // Exit if the panel with the given ID doesn't exist
        }

        deactivateAllPanels(); // Deactivate all panels before activating the selected one
        panel.classList.add('active'); // Add the active class to the selected panel

        // Call the callback function if provided
        if (callback) {
            callback();
        }
    };

    // Event handler for panel buttons
    const handlePanelClick = (event: Event) => {
        event.preventDefault();
        const panelBtn = event.target as HTMLButtonElement;

        if (panelBtn.classList.contains('active')) {
            return; // Exit if the clicked button is already active
        }

        const panelId = panelBtn.dataset.target;

        if (panelId) {
            deactivateAllButtons(); // Remove the active class from all buttons
            panelBtn.classList.add('active'); // Add the active class to the clicked button
            togglePanel(panelId); // Toggle the panel associated with the clicked button
        }
    };

    // Initialize by adding event listeners to all buttons with the class 'js-btn-tab-nav'
    const initPanels = () => {
        const panelBtns =
            panelContainer.querySelectorAll<HTMLButtonElement>('.js-btn-tab-nav');
        panelBtns.forEach(panelBtn => {
            panelBtn.addEventListener('click', handlePanelClick);
        });
    };

    initPanels();
};

export default Panels;
